import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Cookies from 'universal-cookie';

type FiledRequests = {
  resolve: (value: AxiosResponse) => void,
  reject: (reason?: any) => void,
  config: AxiosRequestConfig
}

const API_URL = process.env.REACT_APP_API_BASEURL ?? 'https://api-demo.timetask.ru/api/';
const cookies = new Cookies();
let errorQueue: FiledRequests[] = [];
let isRefreshing = false;

function processQueue(error: any, token: string | null = null) {
  errorQueue.forEach(async prom => {
    if (token) {
      prom.config.headers!['Authorization'] = `Bearer ${token}`;
      await axios.request(prom.config).then(prom.resolve).catch(prom.reject);
    } else {
      prom.reject(error);
    }
  });
  errorQueue = [];
}

const request = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

request.interceptors.request.use((config) => {
  const authToken = cookies.get('accessToken');
  if (authToken) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }
    return config;
});

request.interceptors.response.use((response) => {
  return response;
}, async (error: AxiosError) => {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !(originalRequest as any)._isRetry) {
    (originalRequest as any)._isRetry = true;

    if (!isRefreshing) {
      isRefreshing = true;
      await axios.post(`${API_URL}Account/refresh`, {
        refreshToken: cookies.get('refreshToken')
      }).then((res) => {        
        cookies.set('accessToken', res.data.token);
        cookies.set('refreshToken', res.data.refreshToken);
        request.defaults.headers['Authorization'] = `Bearer ${res.data.token}`;
        setTimeout(() => {
          processQueue(null, res.data.token);
        }, 100);
        isRefreshing = false;
        originalRequest.headers['Authorization'] = `Bearer ${res.data.token}`;
        // return request.request(originalRequest);
      })
        .catch((err) => {
          processQueue(err, null);
          isRefreshing = false;
          localStorage.removeItem('token');
          localStorage.removeItem('authToken');
          localStorage.removeItem('liveRefreshUntil')
          cookies.remove('accessToken');
          cookies.remove('refreshToken');
          localStorage.setItem('interceptorTry', 'false');
          window.location.replace('/login');
          return Promise.reject(err);
        })
    }
    return new Promise((resolve, reject) => {
      errorQueue.push({
        resolve, 
        reject,
        config: originalRequest
      })
    })
  }
  return Promise.reject(error)
}
);

export default request;
